import cn from "clsx";
import { TextLink } from "@crehana/ui";
import { useLearnLastActivityTranslations } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ErrorMessage = function ErrorMessage(_ref) {
  var className = _ref.className,
    error = _ref.error,
    onRetry = _ref.onRetry,
    alternativeLink = _ref.alternativeLink,
    dataTestId = _ref['data-testid'];
  var _useLearnLastActivity = useLearnLastActivityTranslations(),
    t = _useLearnLastActivity.t;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('flex flex-col items-start', className),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx("p", {
      className: "font-subtitle3 text-base-lighter mb-16",
      children: error
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex items-center",
      children: [alternativeLink && /*#__PURE__*/_jsx(TextLink, {
        className: "mr-16",
        label: alternativeLink.label,
        type: "level3",
        href: alternativeLink.url,
        onClick: alternativeLink.onClick
      }), /*#__PURE__*/_jsx(TextLink, {
        label: t('TRY_AGAIN'),
        type: "level2",
        onClick: onRetry
      })]
    })]
  });
};
export default ErrorMessage;